export default __webpack_public_path__ + "static/media/googleSearchImg.100393f0.PNG";